import { createContext, useContext } from "react";
import { useStore } from "zustand";
export var SearchStoreContext = createContext(null);
export var useSearchStore = function(selector) {
    var store = useContext(SearchStoreContext);
    if (!store) throw new Error("Store is missing the provider");
    return useStore(store, selector);
};
